/// references
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {Icon, DomEvent, Path, LeafletEvent, Map, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker, Layer, GridLayerOptions, latLngBounds, LatLngBounds, GridLayer, FeatureGroup } from 'leaflet';
import { GroupMarkerService } from '../services/group-marker.service';  
import { VehicleApiService } from 'src/app/shared/api/services/vehicle-api.service';
import { MatDialog } from '@angular/material/dialog';
import { MapFilterDialogComponent } from './map-filter/map-filter.component';
import { DialogsService } from 'src/app/shared/dialogs/dialogs-service';
import { GpsTrackPoint } from 'src/app/data/model/gps_tracking';
import { GpsMarkerService } from '../services/gps-marker.service';
import { GpsTrackPointView } from 'src/app/data/model/gps-tracking-view';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { finalize, map, Observable, Subscription, tap } from 'rxjs';
import { UserPortalGroupApiService } from 'src/app/shared/api/services/user-portal-group-api.service';
import { User } from 'src/app/data/model/user';
import { AppSelectors } from 'src/app/store/app-store';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/core/service/auth.service';
import { Vehicle } from 'src/app/data/model/vehicle';
import { mapURL } from 'src/environments/environment.api';

@Component({
  standalone: false,
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [GpsMarkerService],
})
export class MapDialogComponent  implements OnInit {
  @Output() addFilter = new EventEmitter();
  @Output() map$: EventEmitter<Map>= new EventEmitter;
  @Output() zoom$: EventEmitter<number>=new EventEmitter;
  public maps!: Map;
  opened=false;
  static data:any;

  observable_loading$ = this.service.observable_loading$

  zoom!:number;
  a1='../../../../assets/images/special_a1.png';
  a2 = '../../../../assets/images/special_a2.png'; 
  a3 ='../../../../assets/images/special_a3.png';
  a4 = '../../../../assets/images/special4.png';
  b = '../../../../assets/images/special_b.png'; 

  fullscreenOptions: FullscreenOptions = {
    position: 'topleft'
  };

  mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
  @Input() options: MapOptions= {
      layers:[tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    })],
    zoom:10,
    center:latLng(45.800084381319905, 13.38134765625),
  };



  static layer = new FeatureGroup();//new LayerGroup();


  constructor(
    private service: GpsMarkerService,
    private dialogService: DialogsService,
    private groupmarkerService: GroupMarkerService,
    private vehiclemarkerService: GpsMarkerService,
    private portalGroupService:PortalGroupApiService,
    private authService: AuthService,
    private vehicleService: VehicleApiService,
    public dialog: MatDialog){}
    
 
  ngOnInit() {
  }

  openMapFilters(){
    this.dialogService
      .openMapFilters$(MapDialogComponent.data)
      .subscribe();
  }
  /*filters = new (Control.extend({
    options: {position: 'topright'},
    dialogService: this.dialogService,
    onAdd(map:Map){
      const div = DomUtil.create('div', 'div-button');
      div.id = 'div-button';
      DomEvent.disableClickPropagation(div);
      const button = DomUtil.create('button', 'button', div);
      button.innerHTML='<button id="button"><span class="fa fa-filter fa-2x"></span></button>';
      button.title='Filter Button';
      DomEvent.on(button, 'click', this.openMapFilters);
    },
    openMapFilters (){
      this.dialogService
        .openMapFilters$()
        .subscribe();
    }
  }))*/
  toggleDisplayDiv() {  
    this.opened = !this.opened;  
  }  

  get data() {
    return MapDialogComponent.data;
  }

  closeInfo(event: MouseEvent){
    event.stopPropagation();
    MapDialogComponent.data=null;
    MapDialogComponent.layer.clearLayers();
  }

  onMapReady(maps: Map) {
    this.maps = maps;
    this.map$.emit(maps);
    this.zoom = maps.getZoom();
    this.zoom$.emit(this.zoom);
    const img=[
      this.a1,
      this.a2,
      this.a3,
      this.a4,
      this.b
    ];
    const status=[
      'Anomalia 1',
      'Anomalia 2',
      'Anomalia 3',
      'Anomalia 4',
      'Black List'
    ];
    const color=[
      'red',
      'purple',
      'blue',
      'darkblue',
      'black',
      "aliceblue"
    ];
    /*const legend = new (Control.extend({
      options: {position: 'bottomleft'},
      onAdd(map:Map): HTMLElement{
        const div = DomUtil.create('div', 'legend');
        div.style.backgroundColor='#ffffff';
        div.style.opacity='70%';
        for(let i=0; i<status.length; i++){
          div.innerHTML+='<h3 style=color:'+color[i]+'; opacity:100%; text-shadow: 50px  40px 40px '+color[i]+';>'+(" <img src="+ img[i] +" height='30' width='30'>")+status[i]+'</h3>'
          i+1;
        }
        div.style.borderRadius='10px'
        div.style.padding='10px'
        return div
      }
    }));
    legend.addTo(maps);*/
    this.service.setMap(maps);


    MapDialogComponent.layer.addTo(maps);
    this.portalGroupService.getAll().pipe(tap((res:any) => res.results))
      .subscribe((res:any) =>{
        for(var result of res.results ){
          if(result.center_coords != undefined){
            const coords = result.center_coords.split(" ");
            const mark1= coords[1].split("(");
            const mark2= coords[2].split(")");
            const point = new LatLng(mark2[0], mark1[1]);
            maps.flyTo(point, result.center_zoom);
          }
          else {
            maps.flyTo(latLng(42.300084381319905, 12.34134765625), 7.3);
          }
        }
      });
      this.vehiclemarkerService.loadLastPoints(MapDialogComponent.layer);
      let extractionTimeout: any;
      MapDialogComponent.layer.on('layeradd', () => {
        clearTimeout(extractionTimeout);
        extractionTimeout = setTimeout(() => {
          //this.allMarkers = [];
          //this.extractMarkers(this.layer); // as defined above
          const bounds=MapDialogComponent.layer.getBounds();
          if(bounds.isValid()){
            this.maps.fitBounds(MapDialogComponent.layer.getBounds());
          }
          
          //if (this.allMarkers.length) this.updateMarkersForZoom();
        }, 200);
      });
  }


  onMapZoomEnd(e: LeafletEvent) {
    this.zoom = e.target.getZoom();
    this.zoom$.emit(this.zoom);
  }
}
